import { WEBFLOW_SCRIPT_ENV } from '../src/webflow-script-env';
import { simulateClick } from './simulateClick';
import { upsellElements } from './upsellElements';

export const getCloseUpsellCartObserver = () => {
  try {
    const { cartModal, cartWrapper, upsellWrapper } = upsellElements();
    //On Webflow you can't have the cart modal without the cart wrapper,
    //but still test

    if (cartModal && !cartWrapper) {
      if (WEBFLOW_SCRIPT_ENV !== 'production') {
        throw new Error('Cart modal found without cart wrapper');
      }
    }

    if (!cartModal && cartWrapper) {
      if (WEBFLOW_SCRIPT_ENV !== 'production') {
        throw new Error('Cart wrapper found without cart modal');
      }
    }

    if (cartModal && cartWrapper) {
      const closeUpsellObserver = new MutationObserver(function (mutations) {
        mutations.forEach(async (mutation) => {
          // Close upsell
          if (mutation.type === 'childList') {
            //Determine if upsell open
            const upsellWrapperStyle = window.getComputedStyle(upsellWrapper);
            const upsellWrapperDisplay = upsellWrapperStyle.display;

            //means upsell is shown
            if (upsellWrapperDisplay !== 'none') {
              const closeUpsellArray = document.querySelectorAll(
                '[data-fp="upsell-close"]'
              );
              const closeUpsell = closeUpsellArray[0];

              simulateClick(closeUpsell);

              const toggleCartButtonArray = document.querySelectorAll(
                '[data-node-type="commerce-cart-open-link"]'
              );
              const toggleCartButton = toggleCartButtonArray[0];

              //Close the upsell and show the cart
              simulateClick(cartWrapper);
              simulateClick(toggleCartButton);
              closeUpsellObserver.disconnect();
            }
          }
        });
      });
      return closeUpsellObserver;
    } else {
      return undefined;
    }
  } catch (error) {
    throw error;
  }
};
